export default __webpack_public_path__ + "static/media/faq-01.1cc60775.svg";